import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    info: {},
    countries: {},
    getJobsData: {
      data: null,
    },
    pressReleases: {},
    mediaReports: {},
    mediaKits: {},
    fetchMediaPending: false,
    fetchJobPending: false,
    sendProblemReportPending: false,
    avamOccupationClassifications: [],
    fetchAvamOccupationClassificationsPending: false,
  },
  actions,
  mutations,
};
